import UnitsFaultNotifications from './UnitsFaultNotifications';

function AudioNotifications() {
  return <UnitsFaultNotifications />;
}

export default AudioNotifications;
